module.exports = __webpack_public_path__ + "public/SiteIcons/menuIcon.svg?3d17a9dd";